"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = require("react");
var useRequests_1 = __importDefault(require("../../../hooks/useRequests"));
var useTranslation_1 = __importDefault(require("../../../hooks/useTranslation"));
var helpers_1 = require("../../../utilities/helpers");
var wofHelpers_1 = require("../../../utilities/wofHelpers");
var Modal_1 = __importDefault(require("../../modal/Modal"));
var Loader_1 = __importDefault(require("../../shared/Loader"));
var ReactWheel_1 = __importDefault(require("./ReactWheel"));
var WofErrorPopup_1 = __importDefault(require("./WofErrorPopup"));
var WofSpot_1 = __importDefault(require("./WofSpot"));
var WofWinModal_1 = __importDefault(require("./WofWinModal"));
var WofContainer = function (_a) {
    var wheelInModal = _a.wheelInModal, options = _a.options, defaultWheelOptions = _a.defaultWheelOptions, children = _a.children, winModalContent = _a.winModalContent, onFinishSpinning = _a.onFinishSpinning, sliceSettings = _a.sliceSettings, setError = _a.setError, winModalTimeoutInMs = _a.winModalTimeoutInMs, prizesSection = _a.prizesSection;
    var t = (0, useTranslation_1.default)("wof").t;
    var _b = (0, useRequests_1.default)(), startMiniGame = _b.startMiniGame, cashInRewardMiniGame = _b.cashInRewardMiniGame;
    var useMock = (0, react_1.useRef)(false);
    var prizeRewardId = (0, react_1.useRef)("");
    var _c = (0, react_1.useState)(false), loadingStart = _c[0], setLoadingStart = _c[1];
    var _d = (0, react_1.useState)(false), loadingSpin = _d[0], setLoadingSpin = _d[1];
    var _e = (0, react_1.useState)([]), data = _e[0], setData = _e[1];
    var _f = (0, react_1.useState)(false), buttonDisabled = _f[0], setButtonDisabled = _f[1];
    var _g = (0, react_1.useState)(false), showWheel = _g[0], setShowWheel = _g[1];
    var _h = (0, react_1.useState)({}), prize = _h[0], setPrize = _h[1];
    var wheelRef = (0, react_1.useRef)();
    var _j = (0, react_1.useState)(false), showWinModal = _j[0], setShowWinModal = _j[1];
    var _k = (0, react_1.useState)(-1), prizeIndex = _k[0], setPrizeIndex = _k[1];
    var _l = (0, react_1.useState)(function () { return function () {
    }; }), spinAction = _l[0], setSpinAction = _l[1];
    var _m = (0, react_1.useState)({
        message: "",
        type: "hidden",
    }), popupMessage = _m[0], setPopupMessage = _m[1];
    var _o = (0, react_1.useState)(false), spinButtonDisabled = _o[0], setSpinButtonDisabled = _o[1];
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var gameId, restOptions, miniGameRewards, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        gameId = options.gameId, restOptions = __rest(options, ["gameId"]);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, startMiniGame(gameId, __assign({}, restOptions), useMock.current)];
                    case 2:
                        miniGameRewards = _a.sent();
                        setData(miniGameRewards.rewards);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        setError(true);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    var formatText = function (segment) {
        if (sliceSettings === null || sliceSettings === void 0 ? void 0 : sliceSettings.formatFn) {
            return sliceSettings.formatFn(segment);
        }
        return [segment.title];
    };
    var formatSegments = function (segments) {
        return segments.map(function (segment) {
            return (0, wofHelpers_1.createWofSlice)({
                style: sliceSettings === null || sliceSettings === void 0 ? void 0 : sliceSettings.style,
                highlightStyle: sliceSettings === null || sliceSettings === void 0 ? void 0 : sliceSettings.highlightStyle,
                values: formatText(segment),
            });
        });
    };
    var getSegmentIndex = function (segments, id) {
        return segments.findIndex(function (segment) { return segment.id === id; });
    };
    var onSpinFinish = function () {
        setShowWheel(false);
        setLoadingSpin(false);
        setTimeout(function () {
            setShowWinModal(true);
            if (onFinishSpinning) {
                onFinishSpinning(prize);
            }
        }, winModalTimeoutInMs);
    };
    var wheelOptions = (0, react_1.useMemo)(function () {
        var wheelShouldBeLoading = Object.keys(prize).length === 0 && prizeRewardId.current === "";
        if (defaultWheelOptions) {
            return (0, wofHelpers_1.createWofOptions)(__assign(__assign({}, defaultWheelOptions), { sliceColor: sliceSettings === null || sliceSettings === void 0 ? void 0 : sliceSettings.sliceColor, winnerSliceColor: sliceSettings === null || sliceSettings === void 0 ? void 0 : sliceSettings.winnerSliceColor, onSpinStop: onSpinFinish, loading: wheelShouldBeLoading, options: formatSegments(data) }));
        }
        return __assign({}, (0, wofHelpers_1.createWofOptions)({
            sliceColor: sliceSettings === null || sliceSettings === void 0 ? void 0 : sliceSettings.sliceColor,
            winnerSliceColor: sliceSettings === null || sliceSettings === void 0 ? void 0 : sliceSettings.winnerSliceColor,
            onSpinStop: onSpinFinish,
            loading: wheelShouldBeLoading,
            options: formatSegments(data),
        }));
    }, [data, prize, defaultWheelOptions, onFinishSpinning, sliceSettings]);
    var getRandomSegmentIndex = function (usedIndexes) {
        var index = (0, helpers_1.getRandomIndex)(data.length, 0);
        if (!usedIndexes.includes(index)) {
            usedIndexes.push(index);
            return data[index];
        }
        return getRandomSegmentIndex(usedIndexes);
    };
    var onStart = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _loop_1, i;
        return __generator(this, function (_a) {
            setButtonDisabled(true);
            setLoadingStart(true);
            if (buttonDisabled) {
                return [2 /*return*/];
            }
            _loop_1 = function (i) {
                var segment = data[i];
                setTimeout(function () {
                    return setData(function (prevData) {
                        return prevData.map(function (prize) {
                            if (segment.id === prize.id) {
                                return __assign(__assign({}, prize), { highlighted: true });
                            }
                            return prize;
                        });
                    });
                }, 650 * i);
            };
            for (i = 0; i < data.length; i++) {
                _loop_1(i);
            }
            setTimeout(function () {
                setShowWheel(true);
                setLoadingStart(false);
            }, 650 * data.length);
            return [2 /*return*/];
        });
    }); };
    var onPopupClose = function () {
        return setPopupMessage({
            message: "",
            type: "hidden",
        });
    };
    var onSpin = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newPrize_1, index, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSpinButtonDisabled(true);
                    setLoadingSpin(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, cashInRewardMiniGame(options, data, useMock.current)];
                case 2:
                    newPrize_1 = _a.sent();
                    setPrize(newPrize_1);
                    index = data.findIndex(function (reward) { return reward.id === newPrize_1.rewardId; });
                    setPrizeIndex(index);
                    prizeRewardId.current = newPrize_1.rewardId;
                    wheelRef.current.spin(index);
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    console.error(err_2);
                    setSpinButtonDisabled(false);
                    setLoadingSpin(false);
                    setError(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onModalClose = function () {
        setData(function (prevData) {
            return prevData.map(function (item) { return (__assign(__assign({}, item), { highlighted: false })); });
        });
        setPrize({});
    };
    var closeModal = function () {
        setShowWinModal(false);
    };
    var renderWheelContent = (0, react_1.useMemo)(function () {
        if (children) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children(onSpin, spinButtonDisabled) });
        }
        return ((0, jsx_runtime_1.jsxs)("button", __assign({ type: "button", disabled: spinButtonDisabled, onClick: onSpin, className: "wof-container--body-button" }, { children: [(0, jsx_runtime_1.jsx)(Loader_1.default, { show: loadingSpin }), t("spinWheel")] })));
    }, [children, spinButtonDisabled, loadingSpin, data]);
    var renderWinModalContent = function (ref) {
        if (winModalContent) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: winModalContent(ref, prize, closeModal) });
        }
        return (0, jsx_runtime_1.jsx)(WofWinModal_1.default, { data: prize, ref: ref });
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)("wof-container--body", !wheelInModal && "wof-container--body--noBg") }, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !!wheelOptions.options.length && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [wheelInModal && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "wof-container--body-wrapper" }, { children: data.map(function (spot, idx) { return ((0, jsx_runtime_1.jsx)(WofSpot_1.default, { spot: spot }, idx)); }) })), (prizesSection === null || prizesSection === void 0 ? void 0 : prizesSection.renderCTASection) ? prizesSection.renderCTASection({
                                loading: loadingStart,
                                buttonDisabled: buttonDisabled,
                                onStart: onStart,
                            }) : (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "wof-container--body-ctas" }, { children: [(0, jsx_runtime_1.jsx)("button", { children: t("noAccount") }), (0, jsx_runtime_1.jsxs)("button", __assign({ onClick: onStart, disabled: buttonDisabled }, { children: [(0, jsx_runtime_1.jsx)(Loader_1.default, { show: loadingStart }), t("start")] }))] })), (0, jsx_runtime_1.jsx)("p", { children: t("dailyAccessPrincess") })] })] })), wheelInModal && ((0, jsx_runtime_1.jsx)(Modal_1.default, __assign({ open: showWheel }, { children: function () { return ((0, jsx_runtime_1.jsx)(ReactWheel_1.default, __assign({ ref: wheelRef }, wheelOptions, { prizeIndex: prizeIndex, spinAction: {
                                action: spinAction,
                                setAction: setSpinAction,
                            } }, { children: renderWheelContent }))); } }))), !wheelInModal && ((0, jsx_runtime_1.jsx)(ReactWheel_1.default, __assign({ ref: wheelRef }, wheelOptions, { prizeIndex: prizeIndex, spinAction: { action: spinAction, setAction: setSpinAction } }, { children: renderWheelContent }))), (0, jsx_runtime_1.jsx)(Modal_1.default, __assign({ onClose: onModalClose, addClickOutsideListener: true, open: showWinModal }, { children: renderWinModalContent })), popupMessage.type !== "hidden" && ((0, jsx_runtime_1.jsx)(WofErrorPopup_1.default, __assign({ onClose: onPopupClose }, popupMessage)))] })) }) })));
};
exports.default = WofContainer;
